const state ={ 
    userInfo:{},
    isInfo:true,
    searchData:''
}

const mutations={ 
    
    updataUserInfo:(state,data)=>{ 
        state.userInfo=data;
    },
    updataIsInfo:(state,data)=>{ 
        state.isInfo=data;
    },
    updataSearchData:(state,data)=>{ 
        state.searchData=data;
    },
}
const actions={ 
    
    updataUserInfo({commit},data){ 
        commit('updataUserInfo',data)
    },
    updataIsInfo({commit},data){ 
        commit('updataIsInfo',data)
    },
    updataSearchData({commit},data){ 
        commit('updataSearchData',data)
    },
   
}
 const getters={
     
     getUserInfo:(state)=>{
        return state.userInfo
    },
     getIsInfo:(state)=>{ 
        return state.isInfo
     },
     getSearchData:(state)=>{ 
        return state.searchData
     },
 }
 export default { 
    state,
    mutations, 
    actions,
    getters
  }